export const version = "strings/5.0.8";
//# sourceMappingURL=_version.js.map